import React from 'react';
import { Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';

interface RejectDraftCardProps {
  rejectReason: string;
  setRejectReason: (value: string) => void;
  isUpdating: boolean;
  onReject: () => void;
}

const RejectDraftCard: React.FC<RejectDraftCardProps> = ({
  rejectReason,
  setRejectReason,
  isUpdating,
  onReject,
}) => (
  <Card variant="outlined">
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Reject Draft
      </Typography>
      <Stack spacing={2}>
        <TextField
          label="Reason (optional)"
          value={rejectReason}
          onChange={(event) => setRejectReason(event.target.value)}
          size="small"
          multiline
          minRows={2}
        />
        <Button
          variant="outlined"
          color="error"
          onClick={onReject}
          disabled={isUpdating}
        >
          {isUpdating ? 'Updating\u2026' : 'Mark as Rejected'}
        </Button>
      </Stack>
    </CardContent>
  </Card>
);

export default RejectDraftCard;
